import type { ColumnDef } from "@tanstack/react-table";
import { StatusBadge } from "@/accounts-payable/common";
import type { ApEmail } from "@/accounts-payable/types";
import { EMAIL_STATUS } from "@/accounts-payable/utils";

export const statusCol: ColumnDef<ApEmail> = {
  accessorKey: "status",
  header: "Status",
  meta: { size: "150px" },
  cell: ({ row }) => <StatusBadge meta={EMAIL_STATUS[row.original.status]} />,
};
